const formatAmount = (amt) => `₹${Number(amt || 0).toLocaleString("en-IN")}`;

// FundOrderReport sends statusCode 0 for every row, so colour by the status text
const STATUS_PILL = {
  requested: "pill-pending",
  accepted: "pill-success",
  approved: "pill-success",
  rejected: "pill-failed",
};
const statusPill = (status) =>
  STATUS_PILL[
    String(status || "")
      .trim()
      .toLowerCase()
  ] || "pill-neutral";

const COLUMNS = 9;

// Rows from FundRequest/FundOrderReport (Add fund page)
// `startIndex` = rows before this page, so S.No continues across pages
export default function FundRequestTable({ rows, loading, startIndex = 0 }) {
  return (
    <div className="table-wrap table-scroll">
      <table className="data-table">
        <tbody>
          <tr>
            <th>S.No</th>
            <th>Transaction Id</th>
            <th>Bank</th>
            <th>Payment mode</th>
            <th className="tright">Amount</th>
            <th>Entry Date</th>
            <th>Approve Date</th>
            <th>Status</th>
            <th>Remark</th>
          </tr>
          {loading ? (
            <tr>
              <td colSpan={COLUMNS} className="empty-note">
                Loading requests...
              </td>
            </tr>
          ) : rows.length === 0 ? (
            <tr>
              <td colSpan={COLUMNS} className="empty-note">
                No fund requests found
              </td>
            </tr>
          ) : (
            rows.map((req, i) => (
              <tr key={req.paymentId}>
                <td className="mono">{startIndex + i + 1}</td>
                <td className="mono">{req.transactionId || "—"}</td>
                <td>
                  {req.bank}
                  <div
                    style={{ fontSize: 10, color: "var(--text-faint)" }}
                    className="mono"
                  >
                    {req.accountNo}
                  </div>
                </td>
                <td>{req.mode}</td>
                <td className="mono tright">{formatAmount(req.amount)}</td>
                <td>{req.entryDate}</td>
                <td>{req.approveDate || "—"}</td>
                <td>
                  <span className={`pill ${statusPill(req.status)}`}>
                    {req.status}
                  </span>
                </td>
                <td>
                  {req.remark ? (
                    <div style={{ fontSize: 11, color: "var(--text-faint)" }}>
                      {req.remark}
                    </div>
                  ) : (
                    "—"
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
